import { render, staticRenderFns } from "./indexb.vue?vue&type=template&id=4b112e4c&scoped=true"
import script from "./indexb.vue?vue&type=script&lang=js"
export * from "./indexb.vue?vue&type=script&lang=js"
import style0 from "./indexb.vue?vue&type=style&index=0&id=4b112e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b112e4c",
  null
  
)

export default component.exports